import { motion } from 'framer-motion';
import { ArrowRight } from 'lucide-react';

const fadeUp = {
  hidden: { opacity: 0, y: 24 },
  show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: 'easeOut' } }
};

export const WelcomeHero = () => {
  const scrollTo = (id) => {
    document.getElementById(id)?.scrollIntoView({ behavior: 'smooth' });
  };

  return (
    <section
      className="relative min-h-[90vh] flex items-center overflow-hidden bg-[linear-gradient(180deg,#0B2240_0%,#0a1d38_60%,#07182F_100%)]"
      data-testid="welcome-hero"
    >
      {/* Subtle pattern overlay */}
      <div className="absolute inset-0 opacity-[0.03]" style={{
        backgroundImage: `radial-gradient(circle at 1px 1px, white 1px, transparent 0)`,
        backgroundSize: '40px 40px'
      }} />

      {/* Accent glow */}
      <div className="absolute top-1/4 -right-32 w-96 h-96 bg-[#D4AF37]/8 rounded-full blur-[120px]" />
      <div className="absolute bottom-0 left-0 w-full h-px bg-gradient-to-r from-transparent via-[#D4AF37]/30 to-transparent" />

      <div className="relative mx-auto max-w-4xl px-4 sm:px-6 lg:px-8 pt-24 pb-16 text-center">
        <motion.div
          variants={fadeUp}
          initial="hidden"
          animate="show"
          className="space-y-8"
        >
          <h1
            className="font-['Playfair_Display'] text-4xl sm:text-5xl lg:text-6xl leading-[1.15] font-semibold text-white tracking-tight"
            data-testid="welcome-hero-headline"
          >
            You're probably overpaying on taxes.
            <br />
            <span className="text-white/70">
              And your current accountant might not even know it.
            </span>
          </h1>

          <p
            className="text-lg sm:text-xl text-white/70 max-w-2xl mx-auto leading-relaxed"
            data-testid="welcome-hero-subheadline"
          >
            KGOB helps businesses, families, and individuals across the United States keep more of what they earn
            — through proactive tax strategy, not just annual filing.
          </p>

          <div className="flex flex-col sm:flex-row items-center justify-center gap-4 pt-4">
            <button
              onClick={() => scrollTo('assessment')}
              className="group inline-flex items-center gap-2 px-8 py-4 rounded-xl text-[#0B2240] font-semibold text-base bg-[linear-gradient(180deg,#E8D89E_0%,#D4AF37_50%,#B99610_100%)] shadow-[inset_0_1px_0_rgba(255,255,255,0.35),0_4px_20px_rgba(212,175,55,0.3)] hover:brightness-110 transition-all duration-200"
              data-testid="welcome-hero-cta"
            >
              See What You Might Be Missing
              <ArrowRight className="h-5 w-5 group-hover:translate-x-1 transition-transform" />
            </button>

            <button
              onClick={() => scrollTo('contact')}
              className="text-[#E3C96E] hover:text-white text-sm font-medium transition-colors flex items-center gap-1"
              data-testid="welcome-hero-secondary-cta"
            >
              Or skip ahead and talk to an advisor
              <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </motion.div>
      </div>
    </section>
  );
};
